export const ActionTypes = {
  FETCH_ALL_REJECTION_TYPES: 'services/rejection_type/fetch_all_rejection_types',
  SET_ALL_REJECTION_TYPES: 'services/rejection_type/set_all_rejection_types',
};

const fetchAllRejectionTypes = () => ({
  type: ActionTypes.FETCH_ALL_REJECTION_TYPES,
});

const setAllRejectionTypes = ({ allRejectionTypesData }) => ({
  allRejectionTypesData,
  type: ActionTypes.SET_ALL_REJECTION_TYPES,
});
export default {
  fetchAllRejectionTypes,
  setAllRejectionTypes,
};
